var setGradient = function setGradient(color1, color2) {
  return "linear-gradient(225deg, " + color1 + ", " + color2 + ")";
};

export { setGradient };
